<template>
  <div v-if="self.isShow" class="full-screen-popup column">
    <div class="selectStoreTitle row flex-center">
      <div class="iconfont icon-arr backicon" @click="backClick()"></div>
      <span>选择工作单位</span>
    </div>

    <div class="searchbar row flex-center">
      <div class="flex-1">
        <van-search
          placeholder="输入要搜索的工作单位"
          @input="changeWorkName"
          @clear="changeWorkName"
          v-model="name"
          maxlength="64"
        >
        </van-search>
      </div>
      <div class="addnew" @click="addWork()">新增工作单位</div>
    </div>

    <div class="overflow-y flex-1 listScroll" @scroll="workListScroll">
      <div class="shoplist">
        <!---->
        <div
          class="shopitem row flex-center"
          :class="row.name == current ? 'active' : ''"
          v-for="(row, index) in workUnitList"
          :key="index"
          @click="clickStore(row)"
        >
          <div class="flex-1">
            {{ row.name }}
          </div>
          <div
            class="iconfont icon-ok"
            :class="row.name == current ? 'active' : ''"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addbusiness, getWorkUnitApi } from "@/api/base.js";
import { showToast, showConfirmDialog } from "vant";
import { loadingStore } from "@/store/loading.js";
import tool from "@/util/debounce.js";
import func from "@/util/func.js";

export default {
  name: "selectWorkUnit",
  props: {
    self: {
      type: Object,
      required: false,
      default: () => ({
        isShow: false,
        current: "",
      }),
    },
  },
  setup() {
    let loadingS = loadingStore();
    return {
      loadingS,
    };
  },
  data() {
    return {
      workUnitList: [],
      name: "",
      current: 1,
      isEnd: false,
      loading: false,
    };
  },
  mounted() {
    this.loaderList();
  },
  methods: {
    backClick() {
      this.self.isShow = false;
    },
    changeWorkName() {
      const that = this;

      that.workUnitList = [];
      that.loading = false;
      that.isEnd = false;
      that.current = 1;
    },
    clickStore(row) {
      let that = this;
      that.$emit("workChange", {
        name: row.name,
      });
      that.backClick();
    },
    //新增工作单位
    addWork() {
      let that = this;

      if (func.isEmpty(this.name.trim())) {
        showToast("请输入要新建的工作单位名称");
        return;
      }

      const isDuplicate = this.workUnitList.some(
        (item) => item.name === this.name
      );

      if (isDuplicate) {
        showToast("该工作单位已经包含在列表中");
        return;
      }

      showConfirmDialog({
        title: "新增工作单位",
        message: `确认新增并选择 ${this.name} 为工作单位？`,
      })
        .then(() => {
          addbusiness({
            code: "his_patient_work_unit",
            dictValue: this.name,
            sort: 2,
          }).then(() => {
            this.$emit("workChange", {
              name: this.name,
            });
            that.backClick();
          });
        })
        .catch(() => {});
    },
    //获取工作单位
    loaderList() {
      const that = this;
      const { name, current, isEnd } = that;
      let { workUnitList } = that;

      if (isEnd) {
        return;
      }

      const params = {
        name,
        current,
        size: 20,
      };

      this.loading = true;

      that.loadingS.showLoading();

      getWorkUnitApi(params).then((res) => {
        const { records, pages, current } = res.data.data;
        const list = records || [];
        //还没搜索的时候，加未知和前端缓存的数据
        if (name === "" && workUnitList.length === 0) {
          //先添加一个未知选项
          workUnitList.push({
            key: "未知",
            value: "未知",
            name: "未知",
          });
        }

        //后端返回的数据加上
        workUnitList = workUnitList.concat(list);

        that.workUnitList = workUnitList;
        that.current = current + 1;
        that.isEnd = current >= pages;
        that.loading = false;
        that.loadingS.hideLoading();
      });
    },
    workListScroll: tool._debounce(function (e) {
      const scrollTop = e.target.scrollTop;
      const scrollHeight = e.target.scrollHeight;
      const clientHeight = e.target.clientHeight;

      if (
        scrollTop + clientHeight >= scrollHeight - 100 &&
        !this.loading &&
        !this.isEnd
      ) {
        this.loaderList();
      }
    }, 200),
  },
};
</script>

<style lang="scss" scoped>
@keyframes rightin {
  from {
    transform: translateX(100%);
    /* 初始状态在屏幕右侧外 */
  }

  to {
    transform: translateX(0);
    /* 最终状态向左移动到屏幕内 */
  }
}

/* Your styles for selectStore page go here */
.full-screen-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 8;
  background-color: #f6f6f6;
  animation: rightin 0.3s forwards;
  -webkit-animation: rightin 0.3s forwards;
}

.van-search__action {
  padding: 0 0.833rem;
}

.shoplist {
  padding: 0 0.292rem;
}

.shopitem {
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* 控制显示的行数 */
  text-align: left;
  padding: 0.292rem 0.125rem;
  border-bottom: 0.021rem solid #ccc;
  color: #333;

  &.active {
    color: #28b8c3;
  }
}

.icon-ok {
  font-size: 0.333rem;
  color: #ccc;
  &.active {
    color: #28b8c3;
  }
}

.backBtn {
  border: 1px solid #28b8c3;
  color: #28b8c3;
}

.selectStoreTitle {
  padding: 0.217rem 0.208rem 0.217rem 0.208rem;

  font-size: 0.292rem;
  text-align: left;
  background-color: #fff;
  .backicon {
    font-size: 0.375rem;
    color: #28b8c3;
    padding: 0 0.15rem;
  }
}
.searchbar {
  margin-top: 0.15rem;
  background-color: #fff;
  .addnew {
    color: #28b8c3;
    font-size: 0.292rem;
    margin-right: 0.417rem;
  }
}

.listScroll {
  background-color: #fff;
  margin-top: 0.15rem;
}
</style>
